<script>
  export let member = {};
</script>

<style>
  .member {
    display: flex;
    padding-bottom: 1rem;
  }
  .image {
    flex: 0 0 auto;
  }
  img {
    height: 80px;
  }
  .info {
    padding-left: .5em;
  }
  .section-label {
    font-size: 1em;
    margin: 0;
  }
  .title {
    line-height: 1.3;
  }
</style>

{#if 'name' in member}
<div class="member">
  {#if member.imgs.length}
  <div class="image bordered-image">
    {#each member.imgs as url}
      <img src="{url}" alt="{member.name}">
    {/each}
  </div>
  {/if}

  <div class="info">
    <div class="section-label">{member.name}</div>
    <div class="title">{member.title}</div>
  </div>
</div>
{/if}